var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen animated fadeIn",attrs:{"id":"full-screen"}},[_c('span',{staticClass:"close-arrow",on:{"click":function($event){return _vm.$root.$emit('closeFullScreen')}}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }